import React, { useEffect, useState } from 'react';
import Button from '../../components/button';
import { useAngularService } from 'helpers/get_angular_service';
import api from 'helpers/api';

const ConfirmBulkWaiversInviteModal = ({ modalInstance, contactsCount, waiver, submitParams }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const [visibleExamples, setVisibleExamples] = useState<any>({});

  const $rootScope = useAngularService('$rootScope');
  const gym = $rootScope.gym;

  useEffect(() => {
    const url = `/gyms/${gym.id}/waivers/bulk_invites/validate`;
    api.post(url, submitParams).then(
      () => {
        setIsLoading(false);
      },
      (response) => {
        setMessages(response.data);
        setIsLoading(false);
      },
    );
  }, []);

  const cancel = () => {
    modalInstance.dismiss('cancel');
  };

  const submit = () => {
    modalInstance.close();
  };

  const availableForDays = $rootScope.gym.gym_waiver_detail.prefilled_waivers_available_for_days;

  const toggle = (index) => {
    setVisibleExamples({ ...visibleExamples, [index]: !visibleExamples[index] });
  };

  return (
    <div>
      <div className="modal-header">
        <button aria-hidden="true" className="close-modal" onClick={cancel} title="Close">
          <i className="icon-cross"></i>
        </button>
        <h4 className="modal-title">Bulk waiver invites</h4>
      </div>
      {isLoading ? (
        <div className="modal-body">
          <p>Fetching data for selected contacts. Please wait...</p>
        </div>
      ) : (
        <>
          <div className="modal-body">
            <p>
              This will send emails to {contactsCount} contacts, inviting them to sign the waiver{' '}
              <strong>{waiver.name}</strong>.
            </p>
            {messages.length > 0 && (
              <div>
                <p>Please check the following before continuing:</p>
                {messages.map((item, index) => (
                  <div key={index}>
                    <strong>{item.message}</strong>{' '}
                    <Button variant="link" onClick={() => toggle(index)}>
                      {visibleExamples[index] ? 'hide' : 'show'}
                    </Button>
                    {visibleExamples[index] &&
                      item.examples.map((example, exampleIndex) => (
                        <div key={exampleIndex}>{example}</div>
                      ))}
                    <br />
                  </div>
                ))}
              </div>
            )}

            <p>
              Click <strong>Send Invites</strong> below to continue.
            </p>
            <p>Note: This link will expire after {availableForDays} days.</p>
          </div>
          <div className="modal-footer">
            <Button onClick={() => cancel()}>Cancel</Button>
            <Button variant="success" onClick={() => submit()}>
              Send Invites
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

angular.module('gym').value('ConfirmBulkWaiversInviteModal', ConfirmBulkWaiversInviteModal);
